import { IconButton } from '@ksyos/design-system';
import React from 'react';
import type { IEpisodeCategoryOneService } from '@common/interfaces';
import type { UnavailableService } from '@common/interfaces/patientUnavailableServices';
import type { EpisodeCategory } from '../../../../../../common/enums/episodeCategory';
import { translateKey } from '../../../../../translate';
import { ProcessStartWizardButtonRow } from '../../../../elements/ProcessStartWizard/ProcessStartWizardButtonRow';
import { NewProcessButtonRow } from './NewProcessButtonRow';

interface INewProcessNameButtonRowProps {
    episodeCategories: IEpisodeCategoryOneService[];
    onClear: () => Promise<void>;
    onClick: (name: EpisodeCategory) => Promise<void>;
    selectedEpisodeCategory: EpisodeCategory | undefined;
    showCloseButton?: boolean;
    unavailableServices: UnavailableService[];
}

export function NewProcessNameButtonRow(props: INewProcessNameButtonRowProps): React.ReactElement {
    return (
        <ProcessStartWizardButtonRow
            actionComponent={
                props.showCloseButton ? (
                    <IconButton
                        icon="close"
                        labelText="Close"
                        onClick={props.onClear}
                        size="small"
                        variant="filled"
                    />
                ) : undefined
            }
            header
            label={translateKey('home.startService')}
        >
            {props.episodeCategories.map((episodeCategory) => {
                return (
                    <NewProcessButtonRow
                        automation={`processFlowService-${episodeCategory.name}`}
                        data={episodeCategory}
                        key={episodeCategory.name}
                        onClick={props.onClick}
                        previousSelection={props.selectedEpisodeCategory}
                        translationKey="episodeCategoryEnum."
                        unavailableServices={props.unavailableServices}
                    />
                );
            })}
        </ProcessStartWizardButtonRow>
    );
}
